import React, { useContext, useEffect, useState } from 'react';


import EventBusyIcon from "@mui/icons-material/EventBusy";

import {
    Button,
    Card,
    CardContent,
    CardHeader,
    Divider,
    Grid,
    IconButton,
    Link,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    Tooltip,
    Typography
} from '@mui/material';

import DeleteIcon from '@mui/icons-material/Delete';

import { stringToLocaleDateString } from '../../../../helpers';
import { UtenteLink } from '../../../common';
import { NavContext, NavRoutes } from "../../../contexts";
import { CompetenzeContext } from '../CompetenzeContext';

export const CompetenzeList = ({
    searchText,
    itemsPerPage,
    disabled,
    onLoadMore,
    onExport,
    onImport,
    onActionClick,
    ...props
}) => {

    const {
        getRouteTo
    } = useContext(NavContext);

    const {
        state,
    } = useContext(CompetenzeContext);

    const {
        competenze
    } = state;

    const [pageIndex, setPageIndex] = useState(0);
    const pageIndexChangeHandler = (e, index) => {
        setPageIndex(index);
    }

    const [pageSize, setPageSize] = useState(itemsPerPage);
    const pageSizeChangeHandler = (e) => {
        setPageSize(e.target.value)
    }

    const deleteClickHandler = async (data) => {
        if (onActionClick)
            onActionClick("Delete", data);
    }

    const addClickHandler = (data) => {
        if (onActionClick)
            onActionClick("Add", data);
    }

    useEffect(() => {
        if (competenze && onLoadMore) {
            onLoadMore(pageIndex, pageSize, searchText);
        }
    }, [pageIndex, pageSize]);

    useEffect(() => {
        if (competenze && onLoadMore) {
            onLoadMore(0, pageSize, searchText);
        }
    }, [searchText]);

    return (
        <div>
            <Typography
                color="textSecondary"
                gutterBottom
                variant="body2"
                sx={{ marginTop: 3 }}>
                {competenze ? competenze.totalCount : 0}&nbsp;Record trovati
            </Typography>
            <Card>
                <CardHeader
                    titleTypographyProps={{ variant: "h6" }}
                    title={
                        <Grid container justifyContent="space-between">
                            <Grid item>
                                <Typography variant="h6">
                                    Tutte le Competenze
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Button
                                    variant="contained"
                                    disableElevation
                                    color="info"
                                    disabled={disabled}
                                    onClick={addClickHandler}>
                                    Aggiungi
                                </Button>
                            </Grid>
                        </Grid>
                    }
                    sx={{ backgroundColor: "secondary.main", color: "white" }}
                />
                <Divider />
                <CardContent sx={{ padding: 0 }}>
                    <Table>
                        <TableHead sx={{ backgroundColor: "aliceblue", }}>
                            <TableRow>
                                <TableCell style={{ width: "60%" }}>Nome</TableCell>
                                <TableCell style={{ width: "10%" }}>
                                    Inserito da
                                </TableCell>
                                <TableCell align="center" style={{ width: "10%" }}>
                                    Modificato da
                                </TableCell>
                                <TableCell align="center" style={{ width: "10%" }}>
                                    Data inserimento
                                </TableCell>
                                <TableCell align="center" style={{ width: "10%" }}>
                                    Data Modifica
                                </TableCell>
                                <TableCell align="right" />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {competenze && competenze.result.length > 0
                                && competenze.result.map((competenza, index) => {
                                    return (
                                        <TableRow hover key={index}>
                                            <TableCell>
                                                <div sx={{
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                }}>
                                                    <div>
                                                        <Link
                                                            color="textPrimary"
                                                            onClick={() => window.open(getRouteTo(NavRoutes.Competenza, [competenza.id]), "_blank").focus()}
                                                            sx={{ fontWeight: 700, cursor: "pointer" }}>
                                                            {competenza.tipoUfficio.nome}
                                                            {[
                                                                competenza.fineValidita,
                                                            ].some((x) => x && x <= new Date()) && (
                                                                    <EventBusyIcon
                                                                        color={
                                                                            competenza.fineValidita &&
                                                                                competenza.fineValidita <= new Date()
                                                                                ? "error"
                                                                                : "warning"
                                                                        }
                                                                    />
                                                                )}
                                                        </Link>
                                                    </div>
                                                </div>
                                            </TableCell>
                                            <TableCell align="center">
                                                <UtenteLink utenteId={competenza?.creatoDa} />
                                            </TableCell>
                                            <TableCell align="center">
                                                <UtenteLink utenteId={competenza?.aggiornatoDa} />
                                            </TableCell>
                                            <TableCell align="center">
                                                {stringToLocaleDateString(competenza.dataCreazione)}
                                            </TableCell>
                                            <TableCell align="center">
                                                {stringToLocaleDateString(competenza.dataAggiornamento)}
                                            </TableCell>
                                            <TableCell align="right">
                                                <IconButton
                                                    aria-label="delete"
                                                    disabled={disabled}
                                                    onClick={() => deleteClickHandler(competenza)}>
                                                    <Tooltip title="Disabilità competenza">
                                                        <DeleteIcon />
                                                    </Tooltip>
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })
                            }
                        </TableBody>
                    </Table>
                </CardContent>
                <TablePagination
                    component="div"
                    count={competenze ? competenze.totalCount : 0}
                    onPageChange={pageIndexChangeHandler}
                    page={pageIndex}
                    rowsPerPage={pageSize}
                    rowsPerPageOptions={[5, 10, 25]}
                />
            </Card>
        </div>
    );
}